/** @typedef {string} QuestionnaireVersion */
export const QUESTIONNAIRE_VERSION_1 = '1';
export const QUESTIONNAIRE_VERSION_2 = '2';
export const QUESTIONNAIRE_VERSION_IMPORT = 'IMPORT';
/** @enum {QuestionnaireVersion} */
export const QUESTIONNAIRE_VERSION = {
	V1: QUESTIONNAIRE_VERSION_1,
	V2: QUESTIONNAIRE_VERSION_2,
	IMPORT: QUESTIONNAIRE_VERSION_IMPORT,
};
/** @type {QuestionnaireVersion[]} */
export const QUESTIONNAIRE_VERSIONS = [
	QUESTIONNAIRE_VERSION_1,
	QUESTIONNAIRE_VERSION_2,
];
